module.exports = __webpack_public_path__ + "static/media/halfcircle.c34e0329.jpg";